import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import useResponsive from '../../hooks/useResponsive';
import './HeroSection.scss';

const HeroSection: React.FC = () => {
  const { isMobile, isTablet } = useResponsive();

  // Animation effect for headline elements
  useEffect(() => {
    const animateElement = (selector: string, delay: number) => {
      const element = document.querySelector(selector) as HTMLElement;
      if (element) {
        setTimeout(() => {
          element.style.opacity = '1';
          element.style.transform = 'translateY(0)';
        }, delay);
      }
    };

    // Only run animations if not on mobile
    if (!isMobile) {
      // Animate headline parts
      animateElement('.code', 500);
      animateElement('.trend', 1000);
      
      // Animate greater sign with bounce effect
      setTimeout(() => {
        const greater = document.querySelector('.greater') as HTMLElement;
        if (greater) {
          greater.style.opacity = '1';
          greater.classList.add('bounce');
        }
      }, 1500);

      // Animate dots
      const dots = document.querySelectorAll('.dot');
      dots.forEach((dot, index) => {
        setTimeout(() => {
          (dot as HTMLElement).style.opacity = '1';
        }, 2000 + index * 300);
      });

      // Animate company vision
      setTimeout(() => {
        const vision = document.querySelector('.company-vision') as HTMLElement;
        if (vision) {
          vision.style.opacity = '1';
        }
      }, 2500);
    } else {
      // For mobile, just show everything without animations
      document.querySelectorAll('.code, .trend, .greater, .dot, .company-vision').forEach((el) => {
        (el as HTMLElement).style.opacity = '1';
        (el as HTMLElement).style.transform = 'none';
      });
    }
  }, [isMobile]);

  return (
    <section className="hero-section">
      <div className="hero-flex-container">
        <div className="hero-background">
          <div className="image-container">
            <img src="/images/people.png" alt="Personas trabajando en oficina" />
          </div>
          {!isMobile && (
            <>
              <div className="content-grid content-grid-left">
                <div className="content-box">
                  <h2>Nuestra Visión</h2>
                  <p>Empoderar a las empresas a través de tecnología innovadora, impulsando el crecimiento y la eficiencia.</p>
                </div>
              </div>
              <div className="content-grid content-grid-right">
                <div className="content-box">
                  <h2>Nuestros Valores</h2>
                  <p>La innovación, la eficiencia y el crecimiento son el núcleo de todo lo que hacemos.</p>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="hero-content">
          <div className="headline-container">
            <h1 className="headline">
              <span className="code">code</span>
              <span className="greater">&gt;</span>
              <span className="trend">trend</span>
              <span className="dots">
                <span className="dot">.</span>
                <span className="dot">.</span>
                <span className="dot">.</span>
              </span>
            </h1>
          </div>
          <div className="vision-container">
            <p className="company-vision">
              En CodeTrend, nos especializamos en construir <strong>aplicaciones personalizadas adaptadas a tu negocio</strong>.
              {!isMobile && <><br /><br /></>}
              {isMobile && <> </>}
              Asóciate con <strong>nosotros</strong>, y creemos las herramientas que respaldarán tu crecimiento.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;